export const actions = {
    set: 'SET::BASE_API_URL'
  }

  export const setbaseApiUrl = baseApiUrl => ({ type: actions.set, baseApiUrl })
  export const getbaseApiUrl = state => state.baseApiUrl
  
  export default actions